import { ref, Ref } from 'vue'
import { parsePhoneNumber, type ParsedPhoneNumber } from 'awesome-phonenumber'

/**
 * A composable for validating phone numbers
 * @returns {Object} - An object containing the validatePhoneNumber function and the validatedData Ref
 */
export default function usePhoneValidator(): {
  validatePhoneNumber: (phoneNumber: string, returnType?: string) => void
  validatedData: Ref<ParsedPhoneNumber | undefined>
} {
  const isValid = ref(false)
  const formattedNumber = ref('')
  const validatedData = ref<ParsedPhoneNumber | undefined>(undefined)

  const validatePhoneNumber = (phoneNumber: string, returnType = 'e164'): void => {
    const pn = parsePhoneNumber(phoneNumber)
    validatedData.value = pn

    isValid.value = pn.valid
    if (!isValid.value) {
      formattedNumber.value = ''
      return
    }
    formattedNumber.value = pn.number?.[returnType as keyof typeof pn.number] ?? ''
  }

  return {
    validatePhoneNumber,
    validatedData
  }
}
